export default {
      id: "icon-pause-usage",
      viewBox: "-45 0 327 327",
      url: __webpack_public_path__ + "icons.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }